/**
 * Generic sessionStorage helpers for JSON operations.
 */

export type SessionStorage = Record<string, unknown>

export const getJsonSessionItem = <T = unknown>(key: string): T | null => {
  try {
    const raw = sessionStorage.getItem(key)
    if (!raw) return null
    return JSON.parse(raw) as T
  } catch (error) {
    throw new Error('Failed to parse JSON from sessionStorage', { cause: error })
  }
}

export const setJsonSessionItem = (key: string, data: unknown): void => {
  try {
    sessionStorage.setItem(key, JSON.stringify(data))
  } catch (error) {
    throw new Error('Failed to store JSON to sessionStorage', { cause: error })
  }
}

export const removeSessionItem = (key: string): void => {
  try {
    sessionStorage.removeItem(key)
  } catch (error) {
    throw new Error('Failed to remove item from sessionStorage', { cause: error })
  }
}
